import { Container } from "react-bootstrap";
import styles from "../../../assets/styles/ProjectPage.module.css"
import PollTemplatesPageView from "./PollTemplatesPageView";

const PollTemplatesPage = () => {
    return (
        <Container className={styles.projectPage}>
            <>
                <PollTemplatesPageView/>
            </>
        </Container>
    );
};

export default PollTemplatesPage;